import callNativeMethod from './callNativeMethod';
import NATIVEFUNCTION_TYPE from './nativeFunctionType';
import myInterface from './myInterface';

/**
 * @return {*}
 */
const logout = () => {
  const methodBody = {
    functionName: NATIVEFUNCTION_TYPE.logout,
  };
  try {
    callNativeMethod(methodBody);
    return true;
  } catch (error) {
    console.log('inside logout');
    return myInterface && myInterface.logout && myInterface.logout();
  }
};

export default logout;
